import { render, staticRenderFns } from "./ForArtists.vue?vue&type=template&id=76ac9cb3&"
import script from "./ForArtists.vue?vue&type=script&lang=js&"
export * from "./ForArtists.vue?vue&type=script&lang=js&"
import style0 from "./ForArtists.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports